export { default as Comment } from './Comment/Comment';
export { default as CommentList } from './CommentList/CommentList';
export { default as CommentRegisterWrapper } from './CommentRegister/CommentRegisterWrapper';
